/* eslint-disable camelcase */
import {Component} from '@src/lib/San';
import $style from './index.module.less';
import {isInNewApp} from '@src/lib/utils/env';

class FooterTalk extends Component {
    static template = `
        <div
            class="{{$style.footerTalk}} {{isVip && $style.vip}}"
            on-click="invokeApp('charactervideo_footer_button')"
        >
            <div class="{{$style.footerLogo}}"></div>

            <div class="{{$style.footerText}}">
                {{ btnText || '打开文心和ta对话' }}
            </div>
        </div>`;
    initData() {
        return {
            $style,
        };
    }
}

class FooterCommunity extends Component {
    static template = `
        <div class="{{$style.footerCommunity}}  {{isVip && $style.vip}}">
            <div class="{{$style.footerLeftImg}}"></div>
            <div>{{ btnText || '打开APP体验' }}</div>
            <div class="{{$style.footerRightImg}}"></div>
        </div>
    `;
    initData() {
        return {
            $style,
        };
    }
}

class FooterCreateVideo extends Component {
    static template = `
        <div class="{{$style.footerCreateVideo}}">
            <div class="{{$style.footerLeftImg}}"></div>
            <div>{{ btnText || '去文心做同款' }}</div>
        </div>
    `;
    initData() {
        return {
            $style,
        };
    }
}
class FooterMagicRetouchShare extends Component {
    static template = `
        <div class="{{$style.footerMagicRetouchShare}}">
            <div class="{{isInNewApp ? $style.footerLeftImgInner : $style.footerLeftImgOuter}}"></div>
            <div>{{ btnText || '去文心做同款' }}</div>
        </div>
    `;
    initData() {
        return {
            $style,
            isInNewApp,
        };
    }
}
// 模板
class CapsuleButton extends Component {
    static template = `
        <div class="{{$style.cFooterButton}}">
            <slot></slot>
        </div>
    `;
    initData() {
        return {
            $style,
        };
    }

}

// 魔法漫画分享按钮
class FooterComicShare extends Component {
    static template = `
        <div class="{{$style.footerCommunity}} {{$style.comicShare}}  {{isVip && $style.vip}}">
            <div class="{{$style.footerLeftImg}}"></div>
            <div>{{ btnText || '文心APP内阅读' }}</div>
            <div class="{{$style.footerRightImg}}"></div>
        </div>`;
    initData() {
        return {
            $style,
        };
    }
}

export class CFooterButton extends Component {
    static template = `
        <div class="{{$style.cFooter}}" on-click="buttonClick">
            <capsule-button>
                <footer-talk s-if="btnStyle === 'talk'" s-bind="{{{btnText, isVip}}}"/>
                <footer-commity s-else-if="btnStyle === 'community'" s-bind="{{{btnText, isVip}}}"/>
                <footer-create-video s-else-if="btnStyle === 'createVideo'" s-bind="{{{btnText}}}"/>
                <footer-magic-retouch-share s-else-if="btnStyle === 'magicRetouchShare'" s-bind="{{{btnText}}}"/>
                <footer-comic-share s-else-if="btnStyle === 'comicShare'" s-bind="{{{btnText}}}"/>
            </capsule-button>
        </div>
    `;
    static components = {
        'capsule-button': CapsuleButton,
        'footer-talk': FooterTalk,
        'footer-commity': FooterCommunity,
        'footer-create-video': FooterCreateVideo,
        'footer-magic-retouch-share': FooterMagicRetouchShare,
        'footer-comic-share': FooterComicShare,
    };
    // <footer-commity />
    initData() {
        return {
            $style,
            btnText: '',
            btnLogo: '',
            btnStyle: 'talk',
            // btnStyle: 'community',
            isVip: false,
            sceneName: '',
        };
    }
    buttonClick() {
        this.fire('footer-click');
        const sceneName = this.data.get('sceneName');
        const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || null;
        ugInvoke?.execInvoke(sceneName);
        this.fire('log', {
            params: {
                type: 'click',
                value: 'back_to_app',
            },
            ext: {
                click_position: 'mainbutton',
            },
        });

    }
    attached(): void {
        const sceneName = this.data.get('sceneName');
        const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || {};
        const container = this.el;
        const wxTagInfo = {
            wxConf: {
                wxDom: container,
                onClick: () => {},
            },
            sceneName,
        };
        ugInvoke?.renderWxTag?.(wxTagInfo);
    }

}
